import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import Flyout, {
  FlyoutHeader,
  FlyoutPanelContent,
} from 'components/common/omnia/flyout-component';
import { FormattedMessage } from 'react-intl';
import Checkbox from 'components/common/checkbox-component';
import Tooltip from 'components/common/tool-tip-component';
import { ReactComponent as Information } from 'icons/icon-information-tooltip.svg';
import classNames from 'classnames';
import IconButton from 'components/common/icon-button-component';
import { ReactComponent as DragIcon } from 'icons/drag.svg';
import { TooltipOptions } from 'models/utils/common/tooltip-options-model';

export const REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN =
  'report-preview-page-options-dropdown';
export const REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID =
  'report-preview-page-options-dropdown-id';
const ICON_SIZE = 20;
const ELEMENT_TITLE_INDEX = 1;
const COMFORT_LETTER_INDEX = 'comfortLetter'; // This name should be same as in OPTIONS_CHECKBOX_ARRAY for comfortLetter
export const BATCH_BLOCK = 'batch-panel';
export const DRAG_ICON_SIZE = 18;
export const COLUMN_REORDER_TOOLTIP = new TooltipOptions({
  text: 'common.column.reorder.tooltip',
  id: 'preview-column-reorder-tool-tip',
  position: 'left',
});

const ReportPreviewPageDisplayOptions = ({
  reportPreviewPageDisplayOptions,
  setPreviewPageDisplayOptionAction,
  isCftEnabled,
  toggleViews,
  setReOrderedColumnOptions,
  reOrederedOptions,
}) => {
  const [displayMenu, setDisplayMenu] = useState(false);
  const [draggedItem, setDraggedItem] = useState(null);
  const hoveredIndexRef = useRef(0);
  const [isToolTip, setIsToolTip] = useState(true);

  const dispatch = useDispatch();

  const handleDragStart = (item, index) => {
    setDraggedItem(item);
    setIsToolTip(false);
    const hoveredElement = document.getElementById(`item-${index}`);
    if (hoveredElement) {
      // Set the font weight to bold
      hoveredElement.style.fontWeight = 'bold';
    }
  };

  const handleDragEnter = (index) => {
    hoveredIndexRef.current = index;
    removeRulerline();
    const hoveredElement = document.getElementById(`item-${index}`);
    addRulerLine(hoveredElement);
  };
  const handleDragEnd = (index) => {
    setIsToolTip(true);
    const hoveredElement = document.getElementById(`item-${index}`);
    if (hoveredElement) {
      hoveredElement.style.fontWeight = 'normal'; // Reset to normal
    }
    removeRulerline();
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    if (!draggedItem) return;
    const hoveredIndex = hoveredIndexRef.current;
    const updatedList = [...reOrederedOptions];
    const draggedIndex = updatedList.indexOf(draggedItem);
    // Remove the dragged item
    updatedList.splice(draggedIndex, 1);
    // Calculate the insertion index
    const insertionIndex =
      draggedIndex > hoveredIndex ? hoveredIndex + 1 : hoveredIndex;
    // Insert the dragged item at the calculated index
    updatedList.splice(insertionIndex, 0, draggedItem);

    await dispatch(setReOrderedColumnOptions(updatedList));
    setDraggedItem(null);
    hoveredIndexRef.current = null;
    removeRulerline();
  };

  const addRulerLine = (hoveredElement) => {
    if (hoveredElement) {
      const rulerLineDiv = document.createElement('div');
      rulerLineDiv.className = `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN}__ruler-line`;
      // Insert the new div directly after the hovered element
      hoveredElement.parentNode.insertBefore(
        rulerLineDiv,
        hoveredElement.nextSibling,
      );
    }
  };
  const removeRulerline = () => {
    const rulerLine = document.querySelector(
      `.${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN}__ruler-line`,
    );
    if (rulerLine) {
      rulerLine.remove(); // Remove the ruler line when the mouse leaves
    }
  };

  return (
    <div className={REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN}>
      <div
        className={`${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN}__button-container`}
      >
        <Tooltip
          text="report.preview.header.info.label"
          id={`${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-info-tooltip`}
        >
          <Information width={ICON_SIZE} height={ICON_SIZE} />
        </Tooltip>
        <div
          className={classNames(
            `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN}__button-container--item`,
            toggleViews &&
              `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN}__button-container--item__reverse`,
          )}
          onClick={() => setDisplayMenu(!displayMenu)}
        >
          <span
            className={`${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN}__button-container--text`}
          >
            <FormattedMessage id={'report.preview.header.button.label'} />
          </span>
        </div>
      </div>
      <Flyout className={BATCH_BLOCK} show={displayMenu}>
        <FlyoutHeader enableClose onClose={() => setDisplayMenu(!displayMenu)}>
          <h3 className={`${BATCH_BLOCK}__title`}>
            <FormattedMessage id={'report.preview.header.label'} />
          </h3>
        </FlyoutHeader>
        <FlyoutPanelContent className={`${BATCH_BLOCK}__body`}>
          <div className={`${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN}__menu`}>
            <div
              className={`${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN}__menu-options`}
            >
              <div
                className={`${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN}__options`}
              >
                {reOrederedOptions &&
                  reOrederedOptions.map((item, iter) => {
                    return !isCftEnabled &&
                      item.name === COMFORT_LETTER_INDEX ? null : (
                      <div
                        className={`${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN}__checkbox-container`}
                        key={`${item.name}-${item.key}`}
                        id={`item-${iter}`}
                        onDragOver={(e) => e.preventDefault()} // Prevent default to allow drop
                        onDrop={iter > ELEMENT_TITLE_INDEX && handleDrop}
                        onDragEnter={() =>
                          iter > ELEMENT_TITLE_INDEX && handleDragEnter(iter)
                        }
                      >
                        {iter === ELEMENT_TITLE_INDEX + 1 ? (
                          <div
                            className={`${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN}__line-break`}
                          ></div>
                        ) : (
                          ''
                        )}
                        <div
                          className={`${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN}__drag-checkbox`}
                        >
                          <Checkbox
                            name={item.name}
                            checked={reportPreviewPageDisplayOptions[item.name]}
                            masterChecked={
                              iter === 0 &&
                              !Object.values(
                                reportPreviewPageDisplayOptions,
                              ).every((value) => value)
                            }
                            value={item.name}
                            onChange={(key) =>
                              setPreviewPageDisplayOptionAction({ key })
                            }
                            label={item.label}
                            id={`${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-${item.key}`}
                            disabled={iter === ELEMENT_TITLE_INDEX}
                          />
                          {iter > ELEMENT_TITLE_INDEX && (
                            <div
                              key={item.id}
                              draggable
                              onDragStart={() => handleDragStart(item, iter)}
                              onDragEnd={() => handleDragEnd(iter)}
                            >
                              <IconButton
                                id={`${item.key}-icon`}
                                tooltip={isToolTip && COLUMN_REORDER_TOOLTIP}
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                                Icon={DragIcon}
                                iconSize={DRAG_ICON_SIZE}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </FlyoutPanelContent>
      </Flyout>
    </div>
  );
};

export default ReportPreviewPageDisplayOptions;
